import axios from "axios";
import config from "../../../config";

// Poseban klijent BEZ auth interceptora — sticker box je interni LAN servis,
// SDF JWT ne sme da ide ka njemu. FormData bez ručnog Content-Type headera
// (browser sam postavlja boundary; ovako je i CORS "simple request").
const stickerClient = axios.create({
  baseURL: config.stickerService.baseUrl,
  timeout: 120000,
});

class StickerPrintService {
  generateStickers = async ({ entries, print, email, copies, customerEmail }) => {
    const form = new FormData();
    form.append("mode", "batch");
    form.append("entries_json", JSON.stringify(entries));
    form.append("print", print ? "true" : "false");
    form.append("email", email ? "true" : "false");
    if (print) form.append("copies", String(copies || 1));
    if (email) form.append("customer_email", customerEmail);
    const response = await stickerClient.post("/generate", form);
    return response.data;
  };
}

export default new StickerPrintService();
